import React, { useState } from 'react';
import api from '../api';
import { useNavigate, Link } from 'react-router-dom';
import { setAuth } from '../authStorage';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const res = await api.post('/auth/login', { username: email, password });
      const d = res.data || {};
      if (d.token) {
        setAuth({ token: d.token, user: d.user, teams: d.teams });
        navigate('/projects');
      } else {
        setError(d.error || d.message || 'Đăng nhập thất bại');
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Đăng nhập thất bại');
    }
  };

  return (
    <div style={{ maxWidth: 360, margin: '60px auto', padding: 24, border: '1px solid #eee', borderRadius: 8 }}>
      <h2 style={{ textAlign: 'center' }}>Đăng nhập</h2>
      <p style={{ fontSize: 13, color: '#64748b', textAlign: 'center', marginBottom: 20 }}>
        Đăng nhập bằng <strong>email</strong> đã đăng ký và được duyệt. Tài khoản quản trị mẫu: <strong>admin</strong> /{' '}
        <strong>admin123</strong>
      </p>
      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: 16 }}>
          <label>Email đăng nhập</label>
          <input
            type="text"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="username"
            placeholder="admin hoặc email@..."
            style={{ width: '100%', padding: 8, marginTop: 4, boxSizing: 'border-box' }}
          />
        </div>
        <div style={{ marginBottom: 16 }}>
          <label>Mật khẩu</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
            style={{ width: '100%', padding: 8, marginTop: 4, boxSizing: 'border-box' }}
          />
        </div>
        {error && <div style={{ color: 'red', marginBottom: 12 }}>{error}</div>}
        <button
          type="submit"
          style={{
            width: '100%',
            padding: 10,
            background: '#1976d2',
            color: '#fff',
            border: 'none',
            borderRadius: 4,
            fontWeight: 600,
          }}
        >
          Đăng nhập
        </button>
      </form>
      <p style={{ textAlign: 'center', marginTop: 18, fontSize: 14 }}>
        Chưa có tài khoản? <Link to="/register">Đăng ký</Link>
      </p>
    </div>
  );
};

export default LoginPage;
